import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  labelBold: {
    textAlign: 'left',
    fontSize: window.location.pathname.includes('fullscreen') ? '1.75rem' : '1.4rem',
    fontWeight: 550,
    color: '#757779',
    letterSpacing: '0px',
    wordSpacing: '0px',
    whiteSpace: 'nowrap',
    marginBottom: window.location.pathname.includes('fullscreen') ? '0.5rem' : '0.3rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
  },
  labelBoldInlineLeft: {
    display: 'inline-block',
    textAlign: 'left',
    fontSize: window.location.pathname.includes('fullscreen') ? '1.75rem' : '1.4rem',
    fontWeight: 550,
    color: '#757779',
    marginBottom: window.location.pathname.includes('fullscreen') ? '0.5rem' : '0.3rem',
    letterSpacing: '0px',
    wordSpacing: '0px',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
  },
  value: {
    textAlign: 'left',
    fontSize: window.location.pathname.includes('fullscreen') ? '1.75rem' : '1.4rem',
    color: '#E98300',
    letterSpacing: '0px',
    wordSpacing: '0px',
    whiteSpace: 'nowrap',
    marginBottom: window.location.pathname.includes('fullscreen') ? '0.5rem' : '0.3rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
  },
  valueInlineRight: {
    display: 'inline-block',
    textAlign: 'right',
    fontSize: window.location.pathname.includes('fullscreen') ? '1.75rem' : '1.5rem',
    flex: 1,
    paddingRight: '0.3rem',
    color: '#E98300',
    letterSpacing: '0px',
    wordSpacing: '0px',
    whiteSpace: 'nowrap',
    marginBottom: window.location.pathname.includes('fullscreen') ? '0.5rem' : '0.3rem',
    [theme.breakpoints.down('sm')]: {
      fontSize: '1.2rem',
    },
  },
}));
